import { AtTabsProps } from "./at-tabs.types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { cn } from "../../../utils/cn";
import { AtTabsSkeleton } from "./at-tabs-skeleton";

export const AtTabs = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
  disabled = false,
  variant = "standard",
  isLoading = false,
}: AtTabsProps) => {
  const isMini = variant === "mini";

  const handleTabChange = (event: React.SyntheticEvent, newIndex: number) => {
    const selectedTab = tabs[newIndex];
    if (selectedTab) {
      onTabChange?.(selectedTab.value);
    }
  };

  // Find the index of the active tab
  const activeTabIndex = tabs.findIndex((tab) => tab.value === activeTab);

  if (isLoading) {
    return <AtTabsSkeleton />;
  }

  return (
    <div className={className}>
      <Tabs
        value={activeTabIndex !== -1 ? activeTabIndex : 0}
        onChange={handleTabChange}
        aria-label="tabs"
        variant={isMini ? "fullWidth" : "standard"}
        className={cn(
          isMini ? "" : " pt-6 pl-12",
          "!w-full !border-b-2 border-surface-75 !min-h-[27px]",
        )}
        sx={{
          "&.MuiTabs-root": {
            minHeight: isMini ? "27px!important" : "",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "var(--color-primary-500)",
            height: "4px",
          },
          "& .MuiButtonBase-root": {
            paddingTop: isMini ? "16px!important" : "",
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            disabled={disabled}
            className={cn(
              isMini ? "!text-sm" : "!text-lg !px-8",
              "!normal-case",
            )}
            key={tab.value}
            label={tab.label}
            sx={{
              "&.MuiButtonBase-root": {
                fontWeight: "400!important",
                color: "var(--color-surface-200)!important",
                paddingBottom: isMini ? "8px!important" : "",
                paddingTop: isMini ? "16px!important" : "",
                minHeight: isMini ? "27px!important" : "",
              },
              "&.Mui-selected": {
                color: "var(--color-surface-500)!important",
                fontWeight: "600!important",
              },
              "&.Mui-selected:hover": {
                fontWeight: "600!important",
              },
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};
